<template>
  <section id="stats" style="width: 100%">
    <v-img :src="require('@/assets/product-section-bg-img.svg')">
      <v-container>
        <v-row class="text-center my-16" justify="center">
          <v-col cols="12" md="12">
            <div class="heading-h1 mb-5">What’s up for grabs</div>
          </v-col>
          <v-col cols="12" md="12" class="mb-10">
            <div class="product-intro-content">It’s hard to get hyped for a reward you can get any old day of the week. Our catalog is chock full of the games, toys, and gizmos kids know and want real bad.</div>
          </v-col>
          <v-col cols="12" md="12">
            <v-btn color="secondary" :to="{ name: 'Signup' }">Sign up to see more products</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-for="brand in brands" :key="brand.name" cols="12" md="2">
            <div class="text-center">
              <v-img :src="brand.image" :alt="brand.name" contain height="60"/>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-img>
  </section>
</template>

<script>
  export default {
    name: "ProductSection",
    data() {
      return {
        brands: [
          { name: "xbox", image: require("@/assets/xbox-logo.svg") },
          { name: "apple", image: require("@/assets/apple-logo.svg") },
          { name: "nintendo", image: require("@/assets/nintendo-logo.svg") },
          { name: "playStation", image: require("@/assets/playstation-logo.svg") },
          { name: "hasbro", image: require("@/assets/hasbro-logo.svg") },
          { name: "mattel", image: require("@/assets/mattel-logo.svg") },
        ],
      };
    },
  };
</script>

<style lang="scss" scoped>
  .product-intro-content {
    font-family: "Lato", sans-serif;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.3;
    letter-spacing: normal;
    text-align: center;
    color: #000000;
  }
</style>



// WEBPACK FOOTER //
// src/components/LandingPage/ProductSection.vue